module.exports = __webpack_public_path__ + "img/scene5-4.dd1e7051.jpg";